import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMaxWidth } from 'Shared/util/custom-hooks';
import useBrandContext from 'Contexts/brand-context';
import useCustomerContext from 'Contexts/customer-context';
import InlineSvg from 'Shared/components/inline-svg';
import { CSSTransition } from 'react-transition-group';
import { getMenuItems } from './menu-items';
import DefaultMenu from './default-menu';
import MobileMenu from './mobile-menu';
import styles from './menu.css';


const Menu = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [pageHasChanged, setPageHasChanged] = useState(false);
  const location = useLocation();
  const { brandData } = useBrandContext();
  const { customerData } = useCustomerContext();
  const useMobileMenu = useMaxWidth(1150);

  useEffect(() => {
    setShowMobileMenu(false);
    setPageHasChanged(true);
  }, [location]);

  const handleToggleMenuOpen = () => {
    setShowMobileMenu(!showMobileMenu);
    setPageHasChanged(false);
  };

  const menuItems = getMenuItems(brandData.name, customerData.serviceId);

  return (
    <nav>
      {useMobileMenu ? (
        <>
          <CSSTransition
            in={showMobileMenu}
            timeout={250}
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              enterDone: styles.enterDone,
              exit: styles.exit,
              exitActive: styles.exitActive,
            }}
          >
            <InlineSvg
              src="/menu.svg"
              className={styles.menuIcon}
              onClick={handleToggleMenuOpen}
            />
          </CSSTransition>

          <MobileMenu
            showMenu={showMobileMenu}
            items={menuItems}
            currentPage={location.pathname}
            pageHasChanged={pageHasChanged}
          />
        </>
      )
        : (
          <DefaultMenu
            items={menuItems}
            currentPage={location.pathname}
          />
        )}
    </nav>
  );
};

export default Menu;
